/**
 * Formats a permission code into a human-readable label.
 * Prefers the description field when available; falls back to converting
 * the name code (e.g. "sign_off.perform" → "Perform Sign Off").
 */
export function formatPermissionLabel(
  permission: { name: string; description?: string | null } | null | undefined
): string {
  if (!permission) return "—";
  if (permission.description) return permission.description;
  // Convert code like "sign_off.perform" → "Perform Sign Off"
  const [resource, action] = permission.name.split(".");
  const toTitle = (s: string) =>
    s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  if (action) return `${toTitle(action)} ${toTitle(resource)}`;
  return toTitle(permission.name);
}

/**
 * Formats workflow/accessioning type identifiers to human-readable labels
 * e.g., "tc_only" -> "TC Only", "pass_through" -> "Pass-Through"
 */
export function formatWorkflowType(type: string): string {
  const labels: Record<string, string> = {
    global: "Global",
    pass_through: "Pass-Through",
    consultation: "Consultation",
    tc_only: "TC Only",
  };
  return (
    labels[type] ||
    type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

const ERROR_DISPLAY_NAMES: Record<string, string> = {
  SpecNotRcvd: "Specimen Not Received",
  PatData: "Patient Data Missing",
  NoSpec: "No Specimen in Container",
};

export function getErrorDisplayName(
  errorCode: string | null | undefined
): string {
  if (!errorCode) return "Unknown";
  return ERROR_DISPLAY_NAMES[errorCode] || errorCode;
}

export function errorRefLabel(refNumber?: number | null): string {
  return refNumber != null ? `E${refNumber}` : "";
}

export function correctionRefLabel(refNumber?: number | null): string {
  return refNumber != null ? `C${refNumber}` : "";
}
